<template>
  <div class='lt-scene-eating'>
    <Transition name='lt-t-eating'>
      <img
        src="../../assets/eatout-1.svg"
        class="lt-scene-eatout_1"
        alt=""
        v-show="eatout === 1"
      />
    </Transition>

    <Transition name='lt-t-eating'>
      <img
        src="../../assets/eatout-2.svg"
        class="lt-scene-eatout_2"
        alt=""
        v-show="eatout === 2"
      />
    </Transition>

    <Transition name='lt-t-eating'>
      <img
        src="../../assets/eatout-3.svg"
        class="lt-scene-eatout_3"
        alt=""
        v-show="eatout === 3"
      />
    </Transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.eatout',
    ]),
  },
};
</script>
